import { useContext, useEffect, useState } from "react"
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { MensajeCont } from "../Context/MensajeContext";

export function Alerta2()
{
    const {MensajeContex}=useContext(MensajeCont)
    const [activado,SetActivado]=useState<number>(1)
    const {ActualizacionMensaje}=useContext(MensajeCont)
    const {ActualizacionGuia}=useContext(GuiaBusquedaCont)
    
    useEffect(()=>{
        activador();
    },[])

    useEffect(()=>{
        activador();
    },[MensajeContex])

    const activador=()=>
    {
        if(MensajeContex!="")
        {
            SetActivado(1);
            ActualizacionGuia("-1")
        }

       
    }

    return (
        <>
        {activado==1?MensajeContex!=""?<div className="alert alert-warning alert-dismissible fade show" role="alert" > <i className="bi-exclamation-octagon"></i> <span className="content small">{MensajeContex} </span>
                <button type="button" className="btn-close" onClick={()=>{SetActivado(0);ActualizacionMensaje("")}}></button>
            </div>:null:null}
        </>
    )
}